import * as React from 'react';
import { connect } from 'react-redux';
import { FiMenu, FiArrowLeft } from 'react-icons/fi';

import { openSidebar } from 'services/ui/actions';
// @ts-ignore
import { pushWithStoredSearch } from 'services/router/actions';
import Portal from 'components/Portal';

import './styles.scss';

export interface OwnProps {
    title?: string;
    backTo?: string;
    Actions?: React.ReactNode;
}

interface DispatchProps {
    openSidebar: typeof openSidebar;
    pushWithStoredSearch: typeof pushWithStoredSearch;
}

type Props = OwnProps & DispatchProps;

export class AppBar extends React.PureComponent<Props> {
    handleClick = (): void => {
        const { backTo } = this.props;
        if (backTo) {
            this.props.pushWithStoredSearch(backTo);
        } else {
            this.props.openSidebar();
        }
    };

    render(): React.ReactElement {
        const { title, backTo, Actions } = this.props;

        return (
            <Portal>
                <div className="app-bar">
                    <button
                        className="app-bar-button"
                        onClick={this.handleClick}
                        type="button"
                    >
                        {backTo && (
                            <FiArrowLeft size="24" style={{ height: 45 }} />
                        )}
                        {!backTo && <FiMenu size="24" style={{ height: 45 }} />}
                    </button>
                    <div className="app-bar-title">{title}</div>
                    <div className="app-bar-actions">{Actions}</div>
                </div>
            </Portal>
        );
    }
}

export default connect(null, { openSidebar, pushWithStoredSearch })(AppBar);
